<form [formGroup]="datosClientes" autocomplete="off" (ngSubmit)="enviar()">
  <h3 class="text-left" style="color: #5a1727">Datos Básicos</h3>
  <hr />
  <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
    <mat-label>NIF/CIF/NIE</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      maxlength="15"
      [class.is-invalid]="nifNoValido"
      formControlName="nif"
      (input)="getCliente()"
    />
    <small *ngIf="nifNoValido">
      El NIF/CIF/NIE es <strong>requerido</strong> o Formato Inválido..
    </small>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
    <mat-label>Primer apellido, razón social o denominación</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      maxlength="65"
      [class.is-invalid]="denominacionNoValido"
      formControlName="apellido1"
    />
    <small *ngIf="denominacionNoValido">
      Primer apellido, razón social o denominación es <strong>requerido</strong>
    </small>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
    <mat-label>Segundo Apellido</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      maxlength="30"
      formControlName="apellido2"
    />
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
    <mat-label>Nombre</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      maxlength="50"
      formControlName="nombre"
    />
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
    <mat-label>Sexo</mat-label>
    <select
      matInput
      matNativeControl
      formControlName="sexo"
      
      (change)="setRequiredColaborador()"
    >
      <option label="--Seleccionar--"></option>
      <option value="MUJER">MUJER</option>
      <option value="HOMBRE">HOMBRE</option>
      <option value="EMPRESA">EMPRESA</option>
    </select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
    <mat-label>Fecha Nacimiento</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      placeholder="{{ hoy.toLocaleDateString() }}"
      formControlName="fechaNacimiento"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
    <mat-label>Email</mat-label>
    <input
      matInput
      matNativeControl
      type="email"
      maxlength="120"
      formControlName="email"
    />
    <small *ngIf="emailNoValidoC"> Formato email no válido </small>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
    <mat-label>Teléfono</mat-label>
    <input
      matInput
      matNativeControl
      type="tel"
      class="no-arrow"
      formControlName="telefono"
      [class.is-invalid]="telNoValidoC"
    />
    <small *ngIf="telNoValidoC">
      Teléfono debe tener 9 dígitos y solo números
    </small>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
    <mat-label>Enviar documentación por Correo</mat-label>
    <select matInput matNativeControl formControlName="enviarDocCorreo">
      <option value="0">No</option>
      <option value="1">Si</option>
    </select>
  </mat-form-field>

  <div *ngIf="datosClientes.controls['sexo'].value === 'EMPRESA'">
    <h3 class="text-left" style="color: #5a1727">Datos del Apoderado</h3>

    <hr />
    <div class="row pl-3">
      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Concepto de representación</mat-label>
        <select
          matInput
          matNativeControl
          formControlName="conceptoRepresentacionApoderado"
        >
          <option label="--Seleccionar--"></option>
          <option value="APODERADO">Apoderado</option>
          <option value="REPRESENTANTE">Representante</option>
          <option value="GERENTE ">Gerente</option>
        </select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
      <mat-label>NIF/NIE</mat-label>
      <input
        matInput
        matNativeControl
        type="text"
        maxlength="9"
        formControlName="nifApoderado"
        (input)="getApoderado()"
      />
      <small *ngIf="nifNoValido">
        El NIF/NIE es <strong>requerido</strong> o Formato Inválido..
      </small>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
      <mat-label>Primer apellido</mat-label>
      <input
        matInput
        matNativeControl
        type="text"
        maxlength="50"
        formControlName="apellido1Apoderado"
      />
      <small *ngIf="denominacionNoValido">
        Primer apellido, razón social o denominación es
        <strong>requerido</strong>
      </small>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
      <mat-label>Segundo Apellido</mat-label>
      <input
        matInput
        matNativeControl
        type="text"
        maxlength="50"
        formControlName="apellido2Apoderado"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
      <mat-label>Nombre</mat-label>
      <input
        matInput
        matNativeControl
        type="text"
        maxlength="50"
        formControlName="nombreApoderado"
      />
    </mat-form-field>
  </div>

  <div class="row direccion">
    <div class="col-lg-1 col-md-4 col-sm-12">
      <h3 style="color: #5a1727">Dirección</h3>
    </div>

    <mat-form-field
      [style.visibility]="isDivVisible ? 'visible' : 'hidden'"
      appearance="outline"
      class="col-lg-4 col-md-8 col-sm-12 select"
    >
      <select
        matInput
        matNativeControl
        formControlName="direcciones"
        (change)="cargarDirecciones(false)"
      >
        <option label="--Seleccionar--"></option>
        <option *ngFor="let dir of direcciones" [ngValue]="dir.id">
          {{ dir.direccion }}
        </option>
      </select>
    </mat-form-field>
  </div>
  <hr />

  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
    <mat-label>Provincia</mat-label>
    <select
      matInput
      matNativeControl
      formControlName="provincia"
      (change)="getMunicipio()"
    >
      <option label="--Seleccionar una provincia--"></option>
      <option *ngFor="let prov of provincias" [ngValue]="prov.idprov">
        {{ prov.nomprov }}
      </option>
    </select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
    <mat-label>Municipio</mat-label>
    <select matInput matNativeControl formControlName="poblacion">
      <option label="--Seleccionar un municipio--"></option>
      <option *ngFor="let mun of municipios" [value]="mun.municipio">
        {{ mun.municipio }}
      </option>
    </select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
    <mat-label>Pueblo</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      maxlength="30"
      formControlName="pueblo"
    />
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
    <mat-label>Código Postal</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
      minlength="5"
      maxlength="5"
      [class.is-invalid]="cpNoValido"
      formControlName="cp"
    />
    <small *ngIf="cpNoValido">
      El Código Postal es <strong>requerido</strong>
    </small>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
    <mat-label>Siglas</mat-label>
    <select matInput matNativeControl formControlName="tipoVia">
      <option label="--Seleccionar--"></option>
      <option
        *ngFor="let sig of siglas"
        [value]="
          sig.siglacalle +
          ' - ' +
          sig.descripcion.toUpperCase() +
          ' - ' +
          sig.codigosigla
        "
      >
        {{ sig.descripcion }}
      </option>
    </select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-9 col-md-6 col-sm-12">
    <mat-label>Calle(o direccción completa)</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      maxlength="50"
      [class.is-invalid]="direccionNoValido"
      formControlName="direccion"
    />
    <small *ngIf="direccionNoValido">
      La dirección es <strong>requerido</strong>
    </small>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
    <mat-label>Nº</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      maxlength="10"
      [class.is-invalid]="numeroNoValido"
      formControlName="direccionnumero"
    />
    <small *ngIf="numeroNoValido"> El número <strong>requerido</strong> </small>
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
    <mat-label>Piso</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      maxlength="5"
      formControlName="direccionpiso"
    />
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
    <mat-label>Puerta</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      maxlength="5"
      formControlName="direccionpuerta"
    />
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
    <mat-label>Bloque</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      maxlength="5"
      formControlName="direccionBloque"
    />
  </mat-form-field>

  <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
    <mat-label>Escalera</mat-label>
    <input
      matInput
      matNativeControl
      type="text"
      maxlength="5"
      formControlName="direccionEscalera"
    />
  </mat-form-field>
  <div class="col-lg-3 col-md-8 col-sm-12" *ngIf="isvendedor === false">
    <mat-checkbox (change)="setSameDirection($event)" [disabled]="check()"
      >Misma dirección para envío de documentación</mat-checkbox
    >
  </div>

  <div *ngIf="isDivVisibleC && isvendedor === false">
    <div class="row direccion">
      <div class="col-lg-5 col-md-4 col-sm-12">
        <h3 style="color: #5a1727">Dirección de envío de documentación</h3>
      </div>
      <mat-form-field
        [style.visibility]="isDivVisible ? 'visible' : 'hidden'"
        appearance="outline"
        class="col-lg-4 col-md-8 col-sm-12 select"
      >
        <select
          matInput
          matNativeControl
          formControlName="direcciones"
          (change)="cargarDirecciones(true)"
        >
          <option label="--Seleccionar--"></option>
          <option *ngFor="let dir of direcciones" [ngValue]="dir.id">
            {{ dir.direccion }}
          </option>
        </select>
      </mat-form-field>
    </div>
    <hr />

    <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
      <mat-label>Provincia</mat-label>
      <select
        matInput
        matNativeControl
        formControlName="direccionCorrespondenciaClienteProvincia"
        (change)="getMunicipioCorresp()"
      >
        <option label="--Seleccionar una provincia--"></option>
        <option *ngFor="let prov of provinciasCorresp" [ngValue]="prov.idprov">
          {{ prov.nomprov }}
        </option>
      </select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
      <mat-label>Municipio</mat-label>
      <select
        matInput
        matNativeControl
        formControlName="direccionCorrespondenciaClientePoblacion"
      >
        <option label="--Seleccionar un municipio--"></option>
        <option *ngFor="let mun of municipiosCorresp" [value]="mun.municipio">
          {{ mun.municipio }}
        </option>
      </select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-lg-2 col-md-6 col-sm-12">
      <mat-label>Código Postal</mat-label>
      <input
        matInput
        matNativeControl
        type="number"
        maxlength="5"
        [class.is-invalid]="cpNoValidoC"
        formControlName="direccionCorrespondenciaClienteCP"
      />
      <small *ngIf="cpNoValidoC">
        El Código Postal es <strong>requerido</strong>
      </small>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
      <mat-label>Calle</mat-label>
      <input
        matInput
        #direcc
        matNativeControl
        maxlength="50"
        type="text"
        [class.is-invalid]="direccionNoValidoC"
        formControlName="direccionCorrespondenciaCliente"
      />
      <mat-hint align="end">{{ direcc.value.length }}/50</mat-hint>
      <small *ngIf="direccionNoValidoC">
        La dirección es <strong>requerido</strong>
      </small>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
      <mat-label>Nº</mat-label>
      <input
        matInput
        matNativeControl
        type="text"
        maxlength="10"
        [class.is-invalid]="numeroNoValidoC"
        formControlName="direccionCorrespondenciaClienteNumero"
      />
      <small *ngIf="numeroNoValidoC">
        El número <strong>requerido</strong>
      </small>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
      <mat-label>Piso</mat-label>
      <input
        matInput
        matNativeControl
        type="text"
        maxlength="5"
        formControlName="direccionCorrespondenciaClientePiso"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
      <mat-label>Puerta</mat-label>
      <input
        matInput
        matNativeControl
        type="text"
        maxlength="5"
        formControlName="direccionCorrespondenciaClientePuerta"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
      <mat-label>Bloque</mat-label>
      <input
        matInput
        matNativeControl
        type="text"
        maxlength="5"
        formControlName="direccionCorrespondenciaClienteBloque"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-lg-1 col-md-3 col-sm-6">
      <mat-label>Escalera</mat-label>
      <input
        matInput
        matNativeControl
        type="text"
        maxlength="5"
        formControlName="direccionCorrespondenciaClienteEscalera"
      />
    </mat-form-field>
  </div>

  <div class="row mt-3" style="margin-bottom: 3rem">
    <div
      class="col-6 text-right"
      [style.visibility]="ocultar ? 'visible' : 'hidden'"
    >
      <button mat-button class="btn-danger" matStepperPrevious>Atras</button>
    </div>

    <div class="col-6 text-left">
      <button
        mat-button
        type="submit"
        class="btn-info"
        [disabled]="datosClientes.get('telefono').value.toString().length > 9"
        matStepperNext
      >
        Siguiente
      </button>
    </div>
  </div>
</form>
